import { WORK_ORDER_VIEW, WORK_ORDER_ADD } from '@/fixtures'

export default {
  path: 'work-order',
  component: () => import('@/views/Route'),
  children: [
    {
      path: '',
      name: 'Work Order',
      component: () => import('@/views/menus/WorkOrder/Index'),
      meta: {
        permission: WORK_ORDER_VIEW
      }
    },
    {
      path: ':id/detail',
      name: 'Detail Work Order',
      component: () => import('@/views/menus/WorkOrder/View'),
      meta: {
        permission: WORK_ORDER_VIEW
      }
    },
    {
      path: 'create',
      name: 'Create Work Order',
      component: () => import('@/views/menus/WorkOrder/Create'),
      meta: {
        permission: WORK_ORDER_ADD
      }
    },
    {
      path: ':id/edit',
      name: 'Edit Work Order',
      component: () => import('@/views/menus/WorkOrder/Edit'),
      meta: {
        permission: WORK_ORDER_ADD
      }
    }
  ]
}
